import type {DatabaseTableType} from "../Database.types";
import {IPublicationApiEntity} from "data/Api/Publication";

export const PUBLICATION_COLUMNS = '++id, sourceData';

export type TPublicationTable = DatabaseTableType & IPublicationApiEntity;
